module.exports = __webpack_public_path__ + "media/images/ic-file-pdf-ae1ccb42af76618582088551b2d70880.svg";